import { call, put } from "redux-saga/effects";
import { Creators as StockItemActions } from "../ducks/stockItem";
import {
  callStockItemIndex,
  callStockItemShow,
  callStockItemSave,
  callStockItemDelete,
  callStockItemToggleStatus,
} from "../../services/stockItemService";
import { notification } from "antd";

export function* indexStockItem(action) {
  try {
    const { data } = yield call(callStockItemIndex, action.payload);
    const { page, size, sorter, filters } = action.payload;
    yield put(
      StockItemActions.indexStockItemSuccess(data.results || data, {
        total: data.total || 0,
        page,
        size,
        sorter,
        filters,
      }),
    );
  } catch (error) {
    yield put(StockItemActions.indexStockItemError(error));
  }
}

export function* showStockItem(action) {
  try {
    const { data } = yield call(callStockItemShow, action.payload);
    yield put(StockItemActions.showStockItemSuccess(data.results || data));
  } catch (error) {
    yield put(StockItemActions.showStockItemError(error));
  }
}

export function* saveStockItem(action) {
  try {
    const { data } = yield call(callStockItemSave, action.payload);
    const savedItem = data.results || data;
    notification.success({
      message: action.payload.id
        ? "Item de estoque atualizado com sucesso."
        : "Item de estoque criado com sucesso.",
    });
    yield put(
      StockItemActions.indexStockItem(
        action.payload.groupId,
        action.payload.farmId,
      ),
    );
    yield put(
      StockItemActions.getDropdownStockItem(
        action.payload.groupId,
        action.payload.farmId,
      ),
    );
    yield put(StockItemActions.refreshListDropDownStockItem(savedItem));
    yield put(StockItemActions.saveStockItemSuccess());
  } catch (error) {
    notification.error({ message: "Erro ao salvar item de estoque." });
    yield put(StockItemActions.saveStockItemError(error));
  }
}

export function* getDropdownStockItem(action) {
  try {
    const { data } = yield call(callStockItemIndex, action.payload);
    const results = data.results || data;
    const activeItems = (results || []).filter(
      (item) => item.status === "Active" || item.status === "A",
    );
    yield put(StockItemActions.getDropdownStockItemSuccess(activeItems));
  } catch (error) {
    yield put(StockItemActions.getDropdownStockItemError(error));
  }
}

export function* deleteStockItem(action) {
  try {
    yield call(callStockItemDelete, action.payload);
    yield put(StockItemActions.deleteStockItemSuccess());
    notification.success({ message: "Item de estoque excluído com sucesso." });
    yield put(
      StockItemActions.indexStockItem(
        action.payload.groupId,
        action.payload.farmId,
      ),
    );
  } catch (error) {
    notification.error({ message: "Erro ao excluir item de estoque." });
    yield put(StockItemActions.deleteStockItemError(error));
  }
}

export function* toggleStatusStockItem(action) {
  try {
    yield call(callStockItemToggleStatus, action.payload);
    yield put(StockItemActions.toggleStatusStockItemSuccess());
    notification.success({
      message: action.payload.active ? "Item reativado." : "Item inativado.",
    });
    yield put(
      StockItemActions.showStockItem(
        action.payload.groupId,
        action.payload.farmId,
        action.payload.id,
      ),
    );
    yield put(
      StockItemActions.indexStockItem(
        action.payload.groupId,
        action.payload.farmId,
      ),
    );
  } catch (error) {
    notification.error({ message: "Erro ao alterar status do item." });
    yield put(StockItemActions.toggleStatusStockItemError(error));
  }
}
